export const mailApiEndpoint =
  process.env.REACT_APP_MAIL_API_ENDPOINT ||
  "http://namcor.unicomms.app/mail_php/mail.php?"; // Mail API Endpoint
  // "http://nafau.org.na/php/namcor.php?";
